import React from 'react';
import PeripheralList from '../filterablePeripheralList/peripheralList';
import '../filterablePeripheralList/peripheralList/peripheralList.css';
import GPIORow from './gpioRow';
import KSxRow from './ksxRow';
import PWMRow from './pwmRow';

class PinDetailList extends React.Component {

    render() {

        return (
            <div>
                <PeripheralList>
                    {this.props.peripherals.filter((peri) => {
                        return ["gpio", "ksi", "kso", "pwm"].includes(peri.name);
                    }).map((peri) => {
                        let isActive = false;
                        if (peri.name === "gpio") {
                            isActive = peri.pinIO.some((value) => {
                                return value !== 0 && value !== 7;
                            })

                            if (isActive) {
                                let gpios = (peri.pinIO.map((val, pin) => {
                                    if (val !== 0 && val !== 7) {
                                        return <GPIORow pinLocation={pin}
                                                        userPinNames={peri.userPinNames}/>
                                    } else {
                                        return null;
                                    }
                                }));
                                return gpios;
                            } else {
                                return null;
                            }
                        } else {
                            isActive = peri.pinSelection.some((value) => {
                                return value !== null
                            })

                            if (peri.name === "pwm" && isActive) {
                                console.log(peri.chanInst);
                                let pwm = peri.pinSelection.map((pin, idx) => {
                                    if (pin !== -1 && pin !== null) {
                                        return <PWMRow  name={peri.name}
                                                        chanInst={peri.chanInst}
                                                        index={idx}
                                                        pinName={peri.pinNames[idx]}/>
                                    } else {
                                        return null;
                                    }
                                })
                                return pwm;
                            } else if (isActive) {
                                let ksx = peri.pinSelection.map((pin, idx) => {
                                    if (pin !== -1 && pin !== null) {
                                        return <KSxRow  name={peri.name}
                                                        rowCol={peri.rowCol}
                                                        index={idx}
                                                        pinName={peri.pinNames[idx]}/>
                                    } else {
                                        return null;
                                    }
                                })
                                return ksx;
                            } else {
                                return null;
                            }
                        }
                    })}
                </PeripheralList>
            </div>
        )
    }
}

export default PinDetailList;
